<div class="py-4 flex flex-col items-center gap-16" #scrollableBox>
    @for (node of dataQuestionnaire.nodes; track node; let index = $index){
        <div [id]="node.id" class="w-full max-w-sm flex items-center gap-3 rounded-lg bg-white px-4 py-3 shadow">
            <mat-icon [svgIcon]="'mat:' + getIcon(node)" class="text-neutral-600 shrink-0"></mat-icon>
            <span class="text-neutral-600 shrink-0">{{ index + 1 < 10 ? '0' + (index + 1) : index + 1 }}</span>
            <span class="text-neutral-800 truncate">{{ node.template?.values?.title?.[utilsService.languageDefault] }}</span>
        </div>
    }
</div>